export const isNotEndOfTrack = (trackWidth: number, visibleTrackPart: number, visibleTrackWidth: number): boolean =>
  trackWidth - Math.abs(visibleTrackPart) >= visibleTrackWidth * 2;
